"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VatConfig = exports.Location = void 0;
var Location = /** @class */ (function () {
    function Location(_a) {
        var locationId = _a.locationId, name = _a.name, branchName = _a.branchName, menus = _a.menus, _b = _a.zones, zones = _b === void 0 ? [] : _b, _c = _a.config, config = _c === void 0 ? {} : _c, _d = _a.products, products = _d === void 0 ? {} : _d, _e = _a.areas, areas = _e === void 0 ? {} : _e, vatConfig = _a.vatConfig;
        this.locationId = locationId;
        this.name = name;
        this.branchName = branchName;
        this.menus = menus;
        this.zones = zones;
        this.config = config;
        this.products = products;
        this.areas = areas;
        this.vatConfig = vatConfig;
    }
    return Location;
}());
exports.Location = Location;
var VatConfig = /** @class */ (function () {
    function VatConfig(_a) {
        var vatNumber = _a.vatNumber, address = _a.address, prefix = _a.prefix, idSequence = _a.idSequence, sendInvoices = _a.sendInvoices;
        this.vatNumber = vatNumber;
        this.address = address;
        this.prefix = prefix;
        this.idSequence = idSequence;
        this.sendInvoices = sendInvoices;
    }
    return VatConfig;
}());
exports.VatConfig = VatConfig;
